<template>
  <div class="bg-indigo-500 px-16 py-12">
    <div class="max-w-5xl mx-auto space-y-8">
      <h3 class="text-white">
        {{ title }}
      </h3>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
